import styled from 'styled-components';
import { BottomSns } from '../../../common/BottomSnsImg';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { tabletQuery } from '../../../../utils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { REWARD_INFO_CONSTANTS } from '../../../../constants/rewardInfo';

export const RewardInfoPc = () => {
  const { getText } = useTextVariant(REWARD_INFO_CONSTANTS, false);

  return (
    <>
      <Wrap>
        <Row>
          <LabelRed>
            <LabelText>{getText('onlineSatelliteTitle')}</LabelText>
          </LabelRed>
          <CongressContainer>
            <DateText>{getText('onlineDate')}</DateText>
            <Line />
            <AppContainer>
              <img src={ImageUtils.ShowDownApp} alt="" />
              <AppDescText>{getText('appDesc')}</AppDescText>
            </AppContainer>
          </CongressContainer>

          <PartnerWrap>
            <PartnerContainer>
              <PartnerTitle>{getText('partnerTitle')}</PartnerTitle>
              <PartnerContent>
                <img src={ImageUtils.PartnerIcon} alt="" />
              </PartnerContent>
            </PartnerContainer>

            <RequestKakaoContainer>
              <RequestText>{getText('requestText')}</RequestText>
              <img src={ImageUtils.KakaoIcon} alt="" />
            </RequestKakaoContainer>
          </PartnerWrap>
        </Row>

        <Row>
          <LabelBlue>
            <LabelText>{getText('offlineEventTitle')}</LabelText>
          </LabelBlue>
          <CongressContainer>
            <DateText>{getText('offlineDate')}</DateText>
            <FullText>{getText('fullEventName')}</FullText>
            <LocationContainer>
              <CircleLocation>{getText('venue')}</CircleLocation>
              <LocationText>{getText('venueAddress')}</LocationText>
            </LocationContainer>
          </CongressContainer>
        </Row>
      </Wrap>
      <BottomSns />
    </>
  );
};

const Row = styled.div`
  flex: 1;
  margin-right: 1px;
  margin-left: 1px;
  width: 100%;
  padding-bottom: 20px;

  ${tabletQuery} {
    margin-bottom: 10px;
  }
`;

const RequestKakaoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #222;
  height: 134px;
  flex: 1;

  img {
    margin-left: 22px;
    width: 50px;
  }
`;

const RequestText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  text-align: left;

  span {
    color: #fae100;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6%;
    text-underline-offset: 20%;
    cursor: pointer;
  }
`;

const FullText = styled.h3`
  color: #3fb5ff;
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  margin-top: 22px;
  margin-bottom: 52px;

  span {
    font-size: 20px;
  }
`;

const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 71px;
`;

const CircleLocation = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  padding-left: 60px;
  padding-right: 60px;

  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.88px;

  border-radius: 31px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  background: rgba(0, 0, 0, 0);
  margin-right: 10px;
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.88px;
  text-align: left;
  display: flex;
  align-items: center;
  border-radius: 40px;

  /* margin-bottom: 145px; */

  img {
    margin-right: 4px;
  }
`;

const Wrap = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 170px;
  text-align: center;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;

  ${tabletQuery} {
    align-items: center;
    flex-direction: column;
  }
`;

const Label = styled.div`
  height: 42px;
  width: 100%;
`;

const LabelRed = styled(Label)`
  border-top: 3px solid #d92a76;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
`;

const LabelBlue = styled(Label)`
  border-top: 3px solid #1e95f6;
  background: linear-gradient(91deg, rgba(0, 155, 251, 0.8) 10.71%, rgba(0, 114, 207, 0.8) 84.3%);
`;

const LabelText = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 39px;
  color: rgba(255, 255, 255, 0.9);
`;

const CongressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #222;
  margin-bottom: 2px;
`;

const DateText = styled.h4`
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.44px;
  padding-top: 15px;

  span {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.6);
    font-weight: 400;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: #302e2d;
  margin-top: 10px;
`;

const AppContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  padding-top: 12px;

  img {
    width: 38px;
    margin-right: 12px;
  }
`;

const AppDescText = styled.p`
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.8px;
  text-align: left;

  span {
    font-weight: 700;
  }
`;

const PartnerWrap = styled.div`
  display: flex;
`;

const PartnerContainer = styled.div`
  width: 147px;
  margin-right: 2px;
  margin-bottom: 2px;
  &:last-child {
    margin-right: 0;
  }
`;

const PartnerTitle = styled.h3`
  height: 31px;
  background: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 31px;
  letter-spacing: -0.72px;
`;

const PartnerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 103px;
  background: rgba(0, 0, 0, 0.2);

  img {
    height: 99px;
  }
`;
